export default __webpack_public_path__ + "static/background-image-d27d82aaa4375244da52ee0eb3cca5ba.gif";